import { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/98 backdrop-blur-sm border-t border-lime-400/30 shadow-2xl">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex-1 space-y-2">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-lime-400 text-xl"></i>
              <h3 className="text-white font-medium text-lg">Your Privacy Matters</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              We use essential cookies to ensure our website functions properly and to analyze site traffic. 
              By clicking "Accept", you consent to our use of cookies for analytics purposes. 
              You can manage your preferences at any time. For more information, please review our{' '}
              <a href="/privacy-policy" className="text-lime-400 hover:text-lime-300 underline">
                Privacy Policy
              </a>
              .
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={handleDecline}
              className="px-6 py-3 border border-white/20 text-white rounded-lg hover:bg-white/5 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Decline Optional
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-3 bg-lime-400 text-slate-800 rounded-lg hover:bg-lime-300 transition-colors text-sm font-bold whitespace-nowrap cursor-pointer"
            >
              Accept All Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
